export type NameType = 'uncollapsing';

export const name: NameType = 'uncollapsing';
